import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import BusinessCenterIcon from '@mui/icons-material/BusinessCenter';

import { Breadcrumbs } from '../../components/Breadcrumbs';
import { SpeedDial } from '../../components/SpeedDial';
import {
  PATH_RESOLVABLE_MISSION_TYPES,
  PATH_RESOLVABLE_MISSION_TYPES_NEW,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { ResolvableMissionTypeList } from '../../components/ResolvableMissionTypeList';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

export const ResolvableMissionTypesPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.ResolvableMissionTypes);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Liste des Types de Missions')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_RESOLVABLE_MISSION_TYPES,
            label: 'types de missions',
            key: 'resolvableMissionTypes',
          },
        ]}
      />
      <PageTitle title="Liste des Types de Missions" />
      <ResolvableMissionTypeList />
      <SpeedDial
        actions={[
          {
            id: 'createResolvableMissionType',
            icon: <BusinessCenterIcon />,
            name: 'Créer Type de Mission',
            to: PATH_RESOLVABLE_MISSION_TYPES_NEW,
          },
        ]}
        title="Actions possibles sur les Types de Missions"
      />
    </>
  );
};
